module.exports = __webpack_public_path__ + "img/about-m-slide-22.82fb563a.jpg";